import { CLUB_SELECTOR_PATH } from '@/features/auth/clubSelfRegistrationConfig.js'
import { getClubSelectorPushQuery } from '@/features/auth/useAuthRedirection.js'
import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { getActiveClubId } from '@/features/router/useActiveClub.js'
import { isSuperAdmin } from '@/features/superAdmin/useIsSuperAdmin.js'

function getRouteActiveClubId(to) {
  const activeClubId = to?.query?.activeClubId
  return Array.isArray(activeClubId) ? activeClubId[0] : activeClubId
}

export function redirectLandingWhenClubContextMissing(to) {
  const authStore = useAuthStore()

  if (isSuperAdmin(authStore.myDetails)) {
    return { path: '/super-admin', replace: true }
  }

  const activeClubId = getRouteActiveClubId(to) || getActiveClubId()
  if (activeClubId) {
    return true
  }

  return {
    path: CLUB_SELECTOR_PATH,
    query: getClubSelectorPushQuery(to.fullPath),
    replace: true,
  }
}
